import React from 'react';
import { Container, Row, Col, Fade } from 'reactstrap';
import ReportCard from '../../containers/Cards/Report';

const ReportDashboard = () => (
  <Fade>
    <Container fluid className="mt-3">
      <Row>
        <Col>
          <ReportCard />
        </Col>
      </Row>
    </Container>
  </Fade>
);

export default ReportDashboard;
